import React from 'react';

function renderLinks(text, links) {
  if (!links || links.length === 0) return text;
  let result = text;
  links.forEach(link => {
    const regex = new RegExp(`\\b${link.text}\\b`, 'gi');
    result = result.replace(regex, `<a href="${link.url}" class="text-amber-600 hover:text-amber-700 underline font-medium">${link.text}</a>`);
  });
  return result;
}

const SectionH3 = ({ title, content, links }) => (
  <div className="mb-6 pl-4 border-l-2 border-amber-200">
    <h3 className="text-xl font-semibold text-neutral-800 mb-3">{title}</h3>
    <p className="text-neutral-700 leading-relaxed"
       dangerouslySetInnerHTML={{ __html: renderLinks(content, links) }} />
  </div>
);

const SectionFAQ = ({ faqs }) => (
  <div className="faq-section bg-neutral-50 rounded-xl p-6 mt-6 space-y-3">
    {faqs.map((faq, i) => (
      <details key={i} className="bg-white rounded-lg border group">
        <summary className="px-4 py-3 cursor-pointer font-semibold text-neutral-800 hover:text-amber-600 list-none flex items-center justify-between">
          {faq.q}
          <svg className="w-4 h-4 text-neutral-400 group-open:rotate-180 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="px-4 pb-4 text-neutral-600">{faq.a}</div>
      </details>
    ))}
  </div>
);

const ContentSection = ({ section, idx, links }) => {
  const heading = section.h2;
  const text = section.content;
  const items = section.listItems;
  const subsections = section.h3s;
  const hasFAQ = section.isFAQ;
  const faqs = section.faqs;

  return (
    <section id={`section-${idx}`} className="mb-12">
      <h2 className="text-2xl md:text-3xl font-bold text-neutral-900 mb-4">{heading}</h2>
      {text && (
        <p className="text-neutral-700 mb-6 leading-relaxed" 
           dangerouslySetInnerHTML={{ __html: renderLinks(text, links) }} />
      )}
      {items && (
        <ul className="space-y-2 mb-6">
          {items.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="w-2 h-2 bg-amber-500 rounded-full mt-2 flex-shrink-0" />
              <span className="text-neutral-700">{item}</span>
            </li>
          ))}
        </ul>
      )}
      {subsections && subsections.map((h3, i) => (
        <SectionH3 key={i} title={h3.title} content={h3.content} links={links} />
      ))}
      {hasFAQ && faqs && <SectionFAQ faqs={faqs} />}
    </section>
  );
};

const BlogSections = ({ sections, internalLinks }) => (
  <div>
    {sections.map((section, idx) => (
      <ContentSection key={idx} section={section} idx={idx} links={internalLinks} />
    ))}
  </div>
);

export default BlogSections;
